/* eslint-disable */
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { EScore, EScoreRating } from '../../../services/individualReport';
import { LineElem, PathElem, RectElem, SVGElem } from './IndividualReportProgressBar.styles';

interface IIndividualReportProgressBar {
  score: EScore;
  score_rating: EScoreRating;
}

const bar: Record<EScore, string> = {
  [EScore.LOW]:
    'M0 4C0 1.79086 1.79086 0 4 0H166C168.209 0 170 1.79086 170 4V20C170 22.2091 168.209 24 166 24H4C1.79086 24 0 22.2091 0 20V4Z',
  [EScore.NORMAL]:
    'M0 4C0 1.79086 1.79086 0 4 0H336C338.209 0 340 1.79086 340 4V20C340 22.2091 338.209 24 336 24H4C1.79086 24 0 22.2091 0 20V4Z',
  [EScore.HIGH]:
    'M0 4C0 1.79086 1.79086 0 4 0H508C510.209 0 512 1.79086 512 4V20C512 22.2091 510.209 24 508 24H4C1.79086 24 0 22.2091 0 20V4Z',
};

const IndividualReportProgressBar: FC<IIndividualReportProgressBar> = ({ score, score_rating }) => {
  const theme = useTheme();

  const colors: Record<EScoreRating, string> = {
    [EScoreRating.WEAK]: theme.colors.accent.red[100],
    [EScoreRating.NORMAL]: theme.colors.accent.blue[100],
    [EScoreRating.STRONG]: theme.colors.accent.green[100],
  };

  return (
    <SVGElem xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 24">
      <RectElem x="0.5" y="0.5" width="511" height="23" rx="3.5" />
      <PathElem d={bar[score]} fill={colors[score_rating]} />
      {score === 'low' && <LineElem x1="170.5" y1="24" x2="170.5" />}
      {score !== 'high' && <LineElem x1="340.5" y1="24" x2="340.5" />}
    </SVGElem>
  );
};

export default IndividualReportProgressBar;
